import { useRuntimeConfig } from '#imports'

import translations from './MarketList.translations'

const {
  LISTING_PRICE_DIFFERENCE_LIMIT_IN_PERCENTAGE,
  LISTING_PRICE_DIFFERENCE_MAXIMUM_TARGET_PRICE_MULTIPLIER,
  // TODO https://imperatorz.slack.com/archives/C544PFLFL/p1756305968322459
  // eslint-disable-next-line @backmarket/custom-rules/no-root-scope-composable
} = useRuntimeConfig().public

export const MARKET_LIST_TYPES = {
  WITH_BACKBOX: 'withBackbox',
  WITHOUT_BACKBOX: 'withoutBackbox',
  OFFLINE: 'offline',
}

export const MARKET_LIST_TYPES_LABELS = {
  [MARKET_LIST_TYPES.WITH_BACKBOX]: translations.withBackbox,
  [MARKET_LIST_TYPES.WITHOUT_BACKBOX]: translations.withoutBackbox,
  [MARKET_LIST_TYPES.OFFLINE]: translations.offline,
}

export const PRICE_IS_TO_LOW_RULE = {
  REQUIRED_MINIMUN_TARGET_PRICE: 100,
  LIMIT_IN_PERCENTAGE: Number(
    LISTING_PRICE_DIFFERENCE_LIMIT_IN_PERCENTAGE || 85,
  ),
  MAXIMUM_TARGET_PRICE_MULTIPLIER: Number(
    LISTING_PRICE_DIFFERENCE_MAXIMUM_TARGET_PRICE_MULTIPLIER || 1.08,
  ),
}
